import { createContext } from "react";
import type { Session, User } from "@supabase/supabase-js";

export type AppRole = "coach" | "leader" | "admin";
export type SignupAccountMode = "solo_trial";
export type SignupAuthRole = Extract<AppRole, "coach" | "leader">;
export type SignupOAuthIntentOptions = {
  role: SignupAuthRole;
  accountMode?: SignupAccountMode | null;
};

export interface AuthContextType {
  user: User | null;
  session: Session | null;
  loading: boolean;
  roles: AppRole[];
  signUp: (
    email: string,
    password: string,
    fullName: string | undefined,
    intendedRole: AppRole,
    options?: { accountMode?: SignupAccountMode | null }
  ) => Promise<{ error: Error | null }>;
  signIn: (email: string, password: string) => Promise<{ error: Error | null }>;
  signInWithGoogle: (
    nextPath?: string,
    options?: { forceConsent?: boolean; includeCalendarScope?: boolean; signupIntent?: SignupOAuthIntentOptions | null }
  ) => Promise<{ error: Error | null }>;
  signInWithLinkedIn: (nextPath?: string) => Promise<{ error: Error | null }>;
  signInWithAzure: (nextPath?: string, options?: { signupIntent?: SignupOAuthIntentOptions | null }) => Promise<{ error: Error | null }>;
  signOut: () => Promise<void>;
  ensureProfile: () => Promise<boolean>;
  refreshRoles: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
